const contractorFile = 'contractor';
const supplierFile = 'supplier';
const employeeFile = 'employee';

export { contractorFile, supplierFile, employeeFile };
